// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Space, Table } from "antd";
// import { useNavigate } from "react-router-dom";
// import qs from "qs";
// import "../styles/whatsappcloudreports.css";

// import { handleApiError } from "../utils/errorHandler";

// const PAGE_SIZE_OPTIONS = ["5", "10", "15", "20", "50", "100"];
// const DEFAULT_PAGE_SIZE = 10;
// const SUMMARY_REQUEST_CONCURRENCY = 4;

// const getPercentage = (value, total) =>
//   total > 0 ? `${((value / total) * 100).toFixed(1)}%` : "0.0%";

// const getEmptySummary = () => ({
//   totalPercentage: "0.0%",
//   total: 0,
//   sent: 0,
//   delivered: 0,
//   read: 0,
//   failed: 0,
//   unsent: 0,
//   sentPercentage: "0.0%",
//   deliveredPercentage: "0.0%",
//   readPercentage: "0.0%",
//   failedPercentage: "0.0%",
//   unsentPercentage: "0.0%",
// });

// const parseMatchedData = (matchedData = []) => {
//   const dataSummary = {
//     total: 0,
//     sent: 0,
//     delivered: 0,
//     read: 0,
//     failed: 0,
//     unsent: 0,
//   };

//   matchedData.forEach((item) => {
//     const statuses =
//       item?.webhookResponse?.entry?.[0]?.changes?.[0]?.value?.statuses || [];

//     if (statuses.length > 0) {
//       dataSummary.total += 1;

//       const hasSent = statuses.some((status) => status.status === "sent");
//       const hasDelivered = statuses.some(
//         (status) => status.status === "delivered",
//       );

//       if (hasSent) dataSummary.sent += 1;
//       if (hasDelivered) dataSummary.delivered += 1;

//       const lastStatus = statuses[statuses.length - 1];

//       switch (lastStatus.status) {
//         case "read":
//           dataSummary.read += 1;
//           break;
//         case "failed":
//           dataSummary.failed += 1;
//           break;
//         default:
//           break;
//       }

//       return;
//     }

//     if (item?.apiResponse) {
//       dataSummary.total += 1;

//       const apiStatus =
//         item.apiResponse?.message?.message_status?.toLowerCase();

//       switch (apiStatus) {
//         case "sent":
//           dataSummary.sent += 1;
//           break;
//         case "delivered":
//           dataSummary.delivered += 1;
//           break;
//         case "read":
//           dataSummary.read += 1;
//           break;
//         case "failed":
//           dataSummary.failed += 1;
//           break;
//         default:
//           dataSummary.unsent += 1;
//       }

//       return;
//     }

//     dataSummary.unsent += 1;
//   });

//   return {
//     ...dataSummary,
//     totalPercentage: dataSummary.total > 0 ? "100%" : "0.0%",
//     sentPercentage: getPercentage(dataSummary.sent, dataSummary.total),
//     deliveredPercentage: getPercentage(
//       dataSummary.delivered,
//       dataSummary.total,
//     ),
//     readPercentage: getPercentage(dataSummary.read, dataSummary.total),
//     failedPercentage: getPercentage(dataSummary.failed, dataSummary.total),
//     unsentPercentage: getPercentage(dataSummary.unsent, dataSummary.total),
//   };
// };

// const runWithConcurrency = async (items, limit, worker) => {
//   if (!items.length) return [];

//   const results = new Array(items.length);
//   let nextIndex = 0;

//   await Promise.all(
//     Array.from({ length: Math.min(limit, items.length) }, async () => {
//       while (nextIndex < items.length) {
//         const currentIndex = nextIndex;
//         nextIndex += 1;
//         results[currentIndex] = await worker(items[currentIndex], currentIndex);
//       }
//     }),
//   );

//   return results;
// };

// const StatusMetric = ({
//   className,
//   iconClass,
//   label,
//   percentage,
//   count,
//   loading,
// }) => (
//   <div className={`campcard_reports ${className}`}>
//     <div className="icon">
//       <i className={iconClass}></i>
//     </div>
//     <div className="">
//       <h6 className="card_heading">{label}</h6>
//       {loading ? (
//         <div className="textpercentage">
//           <span className="loading-spinner">Loading...</span>
//           <div className="count">...</div>
//         </div>
//       ) : (
//         <div className="textpercentage">
//           <div className="percentage">{percentage}</div>
//           <div className="count">({count})</div>
//         </div>
//       )}
//     </div>
//   </div>
// );

// const WhatsappCloudReports = () => {
//   const [tabledata, setTableData] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [tableParams, setTableParams] = useState({
//     pagination: {
//       current: 1,
//       pageSize: DEFAULT_PAGE_SIZE,
//     },
//   });

//   const [loading, setLoading] = useState(false);
//   const [rowLoading, setRowLoading] = useState({});
//   const [searchQuery, setSearchQuery] = useState("");

//   const navigate = useNavigate();
//   const requestSeqRef = useRef(0);
//   const summaryCacheRef = useRef(new Map());
//   const currentPage = tableParams.pagination?.current || 1;
//   const pageSize = tableParams.pagination?.pageSize || DEFAULT_PAGE_SIZE;

//   const fetchCampaignReportsData = useCallback(async (ids, requestId) => {
//     const missingIds = ids.filter(
//       (id) => id && !summaryCacheRef.current.has(id),
//     );

//     if (!missingIds.length) {
//       if (requestId !== requestSeqRef.current) return;

//       setTableData((prevTableData) =>
//         prevTableData.map((tableItem) => {
//           const cachedSummary = summaryCacheRef.current.get(tableItem._id);
//           return cachedSummary
//             ? { ...tableItem, summary: cachedSummary }
//             : tableItem;
//         }),
//       );
//       return;
//     }

//     setRowLoading((prev) => {
//       const next = { ...prev };
//       missingIds.forEach((id) => {
//         next[id] = true;
//       });
//       return next;
//     });

//     try {
//       const dataSummaries = await runWithConcurrency(
//         missingIds,
//         SUMMARY_REQUEST_CONCURRENCY,
//         async (id) => {
//           try {
//             const response = await axios.get(
//               `/api/campaignscheduler/outside/get/${id}`,
//             );

//             return {
//               id,
//               summary: parseMatchedData(response.data?.matchedData || []),
//             };
//           } catch (error) {
//             console.error("Error fetching campaign report summary:", id, error);
//             return {
//               id,
//               summary: getEmptySummary(),
//             };
//           }
//         },
//       );

//       if (requestId !== requestSeqRef.current) return;

//       dataSummaries.forEach(({ id, summary }) => {
//         summaryCacheRef.current.set(id, summary);
//       });

//       const summaryById = new Map(
//         dataSummaries.map(({ id, summary }) => [id, summary]),
//       );

//       setTableData((prevTableData) =>
//         prevTableData.map((tableItem) => {
//           const matchingSummary = summaryById.get(tableItem._id);
//           return matchingSummary
//             ? { ...tableItem, summary: matchingSummary }
//             : tableItem;
//         }),
//       );
//     } catch (error) {
//       console.error("Error fetching campaign reports data:", error);
//       handleApiError(error, "Error fetching campaign reports data");
//     } finally {
//       if (requestId === requestSeqRef.current) {
//         setRowLoading((prev) => {
//           const next = { ...prev };
//           missingIds.forEach((id) => {
//             next[id] = false;
//           });
//           return next;
//         });
//       }
//     }
//   }, []);

//   const fetchCampaignData = useCallback(async () => {
//     const requestId = requestSeqRef.current + 1;
//     requestSeqRef.current = requestId;
//     setLoading(true);

//     let idsToFetch = [];

//     try {
//       const params = {
//         startreq: (currentPage - 1) * pageSize,
//         limit: pageSize,
//       };

//       const response = await axios.get(
//         `/api/campaignscheduler/getallwhatsappcloudreport?${qs.stringify(
//           params,
//         )}`,
//       );

//       if (requestId !== requestSeqRef.current) return;

//       const sortedData = [...(response.data?.data || [])].sort(
//         (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
//       );

//       const dataWithCachedSummaries = sortedData.map((item) => {
//         const cachedSummary = summaryCacheRef.current.get(item._id);
//         return cachedSummary ? { ...item, summary: cachedSummary } : item;
//       });

//       setTableData(dataWithCachedSummaries);
//       setTotal(response.data?.totalCount || 0);
//       idsToFetch = sortedData.map((item) => item._id);
//     } catch (error) {
//       if (requestId === requestSeqRef.current) {
//         console.error("Error fetching campaign data:", error);
//         handleApiError(error, "Something went wrong!");
//       }
//     } finally {
//       if (requestId === requestSeqRef.current) {
//         setLoading(false);
//       }
//     }

//     if (idsToFetch.length && requestId === requestSeqRef.current) {
//       fetchCampaignReportsData(idsToFetch, requestId);
//     }
//   }, [fetchCampaignReportsData, currentPage, pageSize]);

//   useEffect(() => {
//     fetchCampaignData();
//   }, [fetchCampaignData]);

//   useEffect(() => {
//     return () => {
//       requestSeqRef.current += 1;
//     };
//   }, []);

//   const handleRefreshCampaign = useCallback(async (_id) => {
//     try {
//       setRowLoading((prev) => ({ ...prev, [_id]: true }));

//       const response = await axios.get(
//         `/api/campaignscheduler/outside/get/${_id}`,
//       );
//       const updatedSummary = parseMatchedData(response.data?.matchedData || []);
//       summaryCacheRef.current.set(_id, updatedSummary);

//       setTableData((prevTableData) =>
//         prevTableData.map((row) =>
//           row._id === _id ? { ...row, summary: updatedSummary } : row,
//         ),
//       );
//     } catch (error) {
//       console.error("Error refreshing campaign:", error);
//       handleApiError(error, "Error refreshing campaign");
//     } finally {
//       setRowLoading((prev) => ({ ...prev, [_id]: false }));
//     }
//   }, []);

//   const handleTableChange = useCallback(
//     (pagination, filters, sorter) => {
//       setTableParams({
//         pagination,
//         filters,
//         ...sorter,
//       });

//       if (pagination.pageSize !== pageSize) {
//         setTableData([]);
//       }
//     },
//     [pageSize],
//   );

//   const filteredData = useMemo(() => {
//     const normalizedSearch = searchQuery.trim().toLowerCase();

//     if (!normalizedSearch) {
//       return tabledata;
//     }

//     return tabledata.filter((contact) =>
//       contact.campaign_id?.toLowerCase().includes(normalizedSearch),
//     );
//   }, [searchQuery, tabledata]);

//   const handleSearch = useCallback((e) => {
//     setSearchQuery(e.target.value);
//   }, []);

//   const handleViewCampaign = useCallback(
//     (id, campaignId) => {
//       navigate(`/dashboard/whatsappcloudreportdetails/${id}`, {
//         state: { campaignId },
//       });
//     },
//     [navigate],
//   );

//   const handleDeleteCampaign = useCallback(
//     async (_id) => {
//       const confirmed = await Swal.fire({
//         title: "Are you sure?",
//         text: "You won't be able to revert this!",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonColor: "#d33",
//         cancelButtonColor: "#3085d6",
//         confirmButtonText: "Yes, delete it!",
//       });

//       if (!confirmed.isConfirmed) {
//         return;
//       }

//       Swal.fire({
//         title: "Deleting...",
//         allowOutsideClick: false,
//         allowEscapeKey: false,
//         didOpen: () => {
//           Swal.showLoading();
//         },
//       });

//       try {
//         await axios.delete(`/api/campaignscheduler/deletewhatsappcloud/${_id}`);
//         summaryCacheRef.current.delete(_id);
//         await fetchCampaignData();
//         Swal.fire("Deleted!", "Campaign deleted successfully!", "success");
//       } catch (error) {
//         handleApiError(error, "Something went wrong!");
//       }
//     },
//     [fetchCampaignData],
//   );

//   const columns = useMemo(
//     () => [
//       {
//         title: "Action",
//         fixed: "left",
//         key: "action",
//         width: 150,
//         align: "center",
//         render: (text, record) => (
//           <Space size="middle">
//             <button
//               onClick={() => handleRefreshCampaign(record._id)}
//               className="delete-btn"
//               id="refresh-btn"
//               disabled={rowLoading[record._id]}
//             >
//               <i className="ri-refresh-line"></i>
//             </button>
//             <button
//               onClick={() => handleDeleteCampaign(record._id)}
//               className="delete-btn"
//             >
//               <i className="ri-delete-bin-fill"></i>
//             </button>
//             <button
//               type="button"
//               className="edit-btn"
//               onClick={() => handleViewCampaign(record._id, record.campaign_id)}
//             >
//               <i className="ri-eye-line"></i>
//             </button>
//           </Space>
//         ),
//       },
//       {
//         title: "Campaign Name",
//         dataIndex: "campaign_id",
//         key: "campaign_id",
//         render: (text) => (text ? `${text.slice(0, 31)}...` : "-"),
//       },
//       {
//         title: "Campaign Status",
//         dataIndex: "summary",
//         key: "summary",
//         render: (text, record) => {
//           const { summary } = record;
//           const isRowLoading = Boolean(rowLoading[record._id]) || !summary;

//           const {
//             totalPercentage = "0.0%",
//             total = 0,
//             sentPercentage = "0.0%",
//             sent = 0,
//             deliveredPercentage = "0.0%",
//             delivered = 0,
//             readPercentage = "0.0%",
//             read = 0,
//             failedPercentage = "0.0%",
//             failed = 0,
//           } = summary || {};

//           return (
//             <div
//               style={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: "10px",
//                 justifyContent: "space-between",
//               }}
//             >
//               <div className="card-container my-3">
//                 <StatusMetric
//                   className="all"
//                   iconClass="ri-notification-3-line"
//                   label="All"
//                   percentage={totalPercentage}
//                   count={total}
//                   loading={isRowLoading}
//                 />
//                 <StatusMetric
//                   className="sent"
//                   iconClass="ri-check-line"
//                   label="Sent"
//                   percentage={sentPercentage}
//                   count={sent}
//                   loading={isRowLoading}
//                 />
//                 <StatusMetric
//                   className="delivered"
//                   iconClass="ri-check-double-line"
//                   label="Delivered"
//                   percentage={deliveredPercentage}
//                   count={delivered}
//                   loading={isRowLoading}
//                 />
//                 <StatusMetric
//                   className="read"
//                   iconClass="ri-eye-line"
//                   label="Read"
//                   percentage={readPercentage}
//                   count={read}
//                   loading={isRowLoading}
//                 />
//                 <StatusMetric
//                   className="failed"
//                   iconClass="ri-close-circle-line"
//                   label="Failed"
//                   percentage={failedPercentage}
//                   count={failed}
//                   loading={isRowLoading}
//                 />
//               </div>
//             </div>
//           );
//         },
//       },
//       {
//         title: "Created On",
//         dataIndex: "createdAt",
//         key: "createdAt",
//         render: (createdAt) => new Date(createdAt).toLocaleString(),
//       },
//     ],
//     [
//       handleDeleteCampaign,
//       handleRefreshCampaign,
//       handleViewCampaign,
//       rowLoading,
//     ],
//   );

//   const tablePagination = useMemo(
//     () => ({
//       ...tableParams.pagination,
//       total,
//       position: "bottomRight",
//       showSizeChanger: true,
//       showQuickJumper: true,
//       pageSizeOptions: PAGE_SIZE_OPTIONS,
//     }),
//     [tableParams.pagination, total],
//   );

//   return (
//     <div className="page-content w-100">
//       <div className="container">
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//               <h4 className="mb-sm-0 py-3">Whatsapp Cloud Campaign Reports</h4>
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-xxl-12">
//             <div id="contactList" className="card">
//               <div className="card-header py-3">
//                 <div className="d-flex align-items-center flex-wrap gap-2">
//                   <div className="d-flex flex-wrap flex-grow-1 gap-2">
//                     <form
//                       className="d-flex"
//                       onSubmit={(e) => e.preventDefault()}
//                     >
//                       <input
//                         className="form-control me-2"
//                         type="search"
//                         id="search"
//                         placeholder="Search"
//                         aria-label="Search"
//                         value={searchQuery}
//                         onChange={handleSearch}
//                       />
//                     </form>
//                   </div>
//                   <div className="flex-shrink-0"></div>
//                 </div>
//                 <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
//                   <div className="flex-shrink-0">
//                     <div className="hstack text-nowrap gap-2 align-item-center"></div>
//                   </div>
//                 </div>
//               </div>
//               <div className="card-body">
//                 <Table
//                   dataSource={filteredData}
//                   columns={columns}
//                   rowKey="_id"
//                   loading={loading}
//                   scroll={{ x: true }}
//                   style={{
//                     overflowX: tabledata.length > 5 ? "scroll" : "hidden",
//                   }}
//                   pagination={tablePagination}
//                   onChange={handleTableChange}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WhatsappCloudReports;
// =========================================================================================
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Space, Table } from "antd";
import { useNavigate } from "react-router-dom";
import qs from "qs";
import "../styles/whatsappcloudreports.css";

import { handleApiError } from "../utils/errorHandler";
import useTableUrlState from "../utils/useTableUrlState";

const PAGE_SIZE_OPTIONS = ["5", "10", "15", "20", "50", "100"];
const DEFAULT_PAGE_SIZE = 10;
const BULK_SUMMARY_ENDPOINT = "/api/campaignscheduler/getcampaignsummariesbulk";

const getEmptySummary = () => ({
  totalPercentage: "0.0%",
  total: 0,
  sent: 0,
  delivered: 0,
  read: 0,
  failed: 0,
  unsent: 0,
  sentPercentage: "0.0%",
  deliveredPercentage: "0.0%",
  readPercentage: "0.0%",
  failedPercentage: "0.0%",
  unsentPercentage: "0.0%",
});

const StatusMetric = ({
  className,
  iconClass,
  label,
  percentage,
  count,
  loading,
}) => (
  <div className={`campcard_reports ${className}`}>
    <div className="icon">
      <i className={iconClass}></i>
    </div>
    <div className="">
      <h6 className="card_heading">{label}</h6>

      {loading ? (
        <div className="textpercentage">
          <span className="loading-spinner">Loading...</span>
          <div className="count">...</div>
        </div>
      ) : (
        <div className="textpercentage">
          <div className="percentage">{percentage}</div>
          <div className="count">({count})</div>
        </div>
      )}
    </div>
  </div>
);

const WhatsappCloudReports = () => {
  const [tabledata, setTableData] = useState([]);
  const [total, setTotal] = useState(0);

  // Page, page size and search live in the address, so Back keeps the view.
  const {
    page: currentPage,
    pageSize,
    q,
    setPagination,
    setQuery,
  } = useTableUrlState("whatsapp-cloud-reports", DEFAULT_PAGE_SIZE);

  const [loading, setLoading] = useState(false);
  const [rowLoading, setRowLoading] = useState({});
  const [searchInput, setSearchInput] = useState(q);

  const navigate = useNavigate();
  const requestSeqRef = useRef(0);

  // ============================================================
  // BACKEND SUMMARY FETCH
  // ============================================================
  // const fetchCampaignSummaries = useCallback(
  //   async (ids, requestId = requestSeqRef.current) => {
  //     if (!ids?.length) {
  //       return new Map();
  //     }

  //     const response = await axios.post(BULK_SUMMARY_ENDPOINT, {
  //       campaignIds: ids,
  //     });

  //     if (requestId !== requestSeqRef.current) {
  //       return new Map();
  //     }

  //     const summaryById = new Map();

  //     (response.data?.data || []).forEach((item) => {
  //       summaryById.set(String(item._id), item.summary || getEmptySummary());
  //     });

  //     return summaryById;
  //   },
  //   [],
  // );

  const fetchCampaignSummaries = useCallback(
    async (ids, requestId = requestSeqRef.current, refresh = false) => {
      if (!ids?.length) {
        return new Map();
      }

      // ============================================================
      // CHUNKING CONFIG
      // ============================================================
      const CHUNK_SIZE = 10;
      const PARALLEL_LIMIT = 3;

      // Split IDs into chunks of 10
      const chunks = [];
      for (let i = 0; i < ids.length; i += CHUNK_SIZE) {
        chunks.push(ids.slice(i, i + CHUNK_SIZE));
      }

      const summaryById = new Map();

      // Send chunks in parallel groups of 3
      for (let i = 0; i < chunks.length; i += PARALLEL_LIMIT) {
        // If a new request came in, abort old ones
        if (requestId !== requestSeqRef.current) {
          return new Map();
        }

        const group = chunks.slice(i, i + PARALLEL_LIMIT);

        const results = await Promise.all(
          group.map((chunk) =>
            axios.post(BULK_SUMMARY_ENDPOINT, { campaignIds: chunk, refresh }),
          ),
        );

        if (requestId !== requestSeqRef.current) {
          return new Map();
        }

        // Merge all summaries from this group
        results.forEach((response) => {
          (response.data?.data || []).forEach((item) => {
            summaryById.set(
              String(item._id),
              item.summary || getEmptySummary(),
            );
          });
        });
      }

      return summaryById;
    },
    [],
  );

  // ============================================================
  // FETCH CAMPAIGNS + ONE BULK SUMMARY REQUEST
  // ============================================================
  const fetchCampaignData = useCallback(async () => {
    const requestId = requestSeqRef.current + 1;
    requestSeqRef.current = requestId;

    setLoading(true);

    try {
      const params = {
        startreq: (currentPage - 1) * pageSize,
        limit: pageSize,
        ...(q ? { q } : {}),
      };

      const response = await axios.get(
        `/api/campaignscheduler/getallwhatsappcloudreport?${qs.stringify(
          params,
        )}`,
      );

      if (requestId !== requestSeqRef.current) {
        return;
      }

      const sortedData = [...(response.data?.data || [])].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      );

      const ids = sortedData.map((item) => String(item._id));

      // Show campaign rows immediately.
      setTableData(
        sortedData.map((item) => ({
          ...item,
          summary: undefined,
        })),
      );

      setTotal(response.data?.totalCount || 0);

      if (!ids.length) {
        return;
      }

      setRowLoading((prev) => {
        const next = { ...prev };

        ids.forEach((id) => {
          next[id] = true;
        });

        return next;
      });

      try {
        // IMPORTANT:
        // Only ONE request is made for all visible campaigns.
        // Summary calculation is now done completely on backend.
        const summaryById = await fetchCampaignSummaries(ids, requestId);

        if (requestId !== requestSeqRef.current) {
          return;
        }

        setTableData((prevTableData) =>
          prevTableData.map((tableItem) => ({
            ...tableItem,
            summary:
              summaryById.get(String(tableItem._id)) || getEmptySummary(),
          })),
        );
      } catch (summaryError) {
        if (requestId === requestSeqRef.current) {
          console.error(
            "Error loading backend campaign summaries:",
            summaryError,
          );

          setTableData((prevTableData) =>
            prevTableData.map((tableItem) => ({
              ...tableItem,
              summary: getEmptySummary(),
            })),
          );

          handleApiError(summaryError, "Error loading campaign summaries");
        }
      } finally {
        if (requestId === requestSeqRef.current) {
          setRowLoading((prev) => {
            const next = { ...prev };

            ids.forEach((id) => {
              next[id] = false;
            });

            return next;
          });
        }
      }
    } catch (error) {
      if (requestId === requestSeqRef.current) {
        console.error("Error fetching campaign data:", error);
        handleApiError(error, "Something went wrong!");
      }
    } finally {
      if (requestId === requestSeqRef.current) {
        setLoading(false);
      }
    }
  }, [fetchCampaignSummaries, currentPage, pageSize, q]);

  useEffect(() => {
    fetchCampaignData();
  }, [fetchCampaignData]);

  useEffect(() => {
    return () => {
      requestSeqRef.current += 1;
    };
  }, []);

  // ============================================================
  // REFRESH ONE CAMPAIGN
  // ============================================================
  const handleRefreshCampaign = useCallback(
    async (_id) => {
      try {
        setRowLoading((prev) => ({
          ...prev,
          [_id]: true,
        }));

        // 🔄 asks the server to recalculate now instead of using saved counts.
        const summaryById = await fetchCampaignSummaries(
          [String(_id)],
          requestSeqRef.current,
          true,
        );

        const updatedSummary =
          summaryById.get(String(_id)) || getEmptySummary();

        setTableData((prevTableData) =>
          prevTableData.map((row) =>
            String(row._id) === String(_id)
              ? {
                  ...row,
                  summary: updatedSummary,
                }
              : row,
          ),
        );
      } catch (error) {
        console.error("Error refreshing campaign summary:", error);

        handleApiError(error, "Error refreshing campaign summary");
      } finally {
        setRowLoading((prev) => ({
          ...prev,
          [_id]: false,
        }));
      }
    },
    [fetchCampaignSummaries],
  );

  const handleTableChange = useCallback(
    (pagination) => {
      if (pagination.pageSize !== pageSize) {
        setTableData([]);
      }
      setPagination(pagination.current, pagination.pageSize);
    },
    [pageSize, setPagination],
  );

  // Search runs on the server across all campaigns (name, WABA number,
  // recipient mobile), once typing pauses.
  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput.trim() !== q) setQuery(searchInput);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchInput, q, setQuery]);

  const handleSearch = useCallback((e) => {
    setSearchInput(e.target.value);
  }, []);

  const handleViewCampaign = useCallback(
    (id, campaignId) => {
      navigate(`/dashboard/whatsappcloudreportdetails/${id}`, {
        state: { campaignId },
      });
    },
    [navigate],
  );

  const handleDeleteCampaign = useCallback(
    async (_id) => {
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (!confirmed.isConfirmed) {
        return;
      }

      Swal.fire({
        title: "Deleting...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await axios.delete(`/api/campaignscheduler/deletewhatsappcloud/${_id}`);

        await fetchCampaignData();

        Swal.fire("Deleted!", "Campaign deleted successfully!", "success");
      } catch (error) {
        handleApiError(error, "Something went wrong!");
      }
    },
    [fetchCampaignData],
  );

  const columns = useMemo(
    () => [
      {
        title: "Action",
        fixed: "left",
        key: "action",
        width: 150,
        align: "center",
        render: (text, record) => (
          <Space size="middle">
            <button
              onClick={() => handleRefreshCampaign(record._id)}
              className="delete-btn"
              id="refresh-btn"
              disabled={rowLoading[record._id]}
            >
              <i className="ri-refresh-line"></i>
            </button>

            <button
              onClick={() => handleDeleteCampaign(record._id)}
              className="delete-btn"
            >
              <i className="ri-delete-bin-fill"></i>
            </button>

            <button
              type="button"
              className="edit-btn"
              onClick={() => handleViewCampaign(record._id, record.campaign_id)}
            >
              <i className="ri-eye-line"></i>
            </button>
          </Space>
        ),
      },
      {
        title: "Campaign Name",
        dataIndex: "campaign_id",
        key: "campaign_id",
        render: (text) => (text ? `${text.slice(0, 31)}...` : "-"),
      },
      {
        title: "Campaign Status",
        dataIndex: "summary",
        key: "summary",
        render: (text, record) => {
          const { summary } = record;

          const isRowLoading = Boolean(rowLoading[record._id]) || !summary;

          const {
            totalPercentage = "0.0%",
            total = 0,
            sentPercentage = "0.0%",
            sent = 0,
            deliveredPercentage = "0.0%",
            delivered = 0,
            readPercentage = "0.0%",
            read = 0,
            failedPercentage = "0.0%",
            failed = 0,
          } = summary || {};

          return (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                justifyContent: "space-between",
              }}
            >
              <div className="card-container my-3">
                <StatusMetric
                  className="all"
                  iconClass="ri-notification-3-line"
                  label="All"
                  percentage={totalPercentage}
                  count={total}
                  loading={isRowLoading}
                />

                <StatusMetric
                  className="sent"
                  iconClass="ri-check-line"
                  label="Sent"
                  percentage={sentPercentage}
                  count={sent}
                  loading={isRowLoading}
                />

                <StatusMetric
                  className="delivered"
                  iconClass="ri-check-double-line"
                  label="Delivered"
                  percentage={deliveredPercentage}
                  count={delivered}
                  loading={isRowLoading}
                />

                <StatusMetric
                  className="read"
                  iconClass="ri-eye-line"
                  label="Read"
                  percentage={readPercentage}
                  count={read}
                  loading={isRowLoading}
                />

                <StatusMetric
                  className="failed"
                  iconClass="ri-close-circle-line"
                  label="Failed"
                  percentage={failedPercentage}
                  count={failed}
                  loading={isRowLoading}
                />
              </div>
            </div>
          );
        },
      },
      {
        title: "Created On",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (createdAt) => new Date(createdAt).toLocaleString(),
      },
    ],
    [
      handleDeleteCampaign,
      handleRefreshCampaign,
      handleViewCampaign,
      rowLoading,
    ],
  );

  const tablePagination = useMemo(
    () => ({
      current: currentPage,
      pageSize,
      total,
      position: "bottomRight",
      showSizeChanger: true,
      showQuickJumper: true,
      pageSizeOptions: PAGE_SIZE_OPTIONS,
    }),
    [currentPage, pageSize, total],
  );

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">Whatsapp Cloud Campaign Reports</h4>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xxl-12">
            <div id="contactList" className="card">
              <div className="card-header py-3">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap flex-grow-1 gap-2">
                    <form
                      className="d-flex"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <input
                        className="form-control me-2"
                        type="search"
                        id="search"
                        placeholder="Search"
                        aria-label="Search"
                        value={searchInput}
                        onChange={handleSearch}
                      />
                    </form>
                  </div>

                  <div className="flex-shrink-0"></div>
                </div>

                <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                  <div className="flex-shrink-0">
                    <div className="hstack text-nowrap gap-2 align-item-center"></div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <Table
                  dataSource={tabledata}
                  columns={columns}
                  rowKey="_id"
                  loading={loading}
                  scroll={{ x: true }}
                  style={{
                    overflowX: tabledata.length > 5 ? "scroll" : "hidden",
                  }}
                  pagination={tablePagination}
                  onChange={handleTableChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappCloudReports;
